import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TEMPLATES_QUERY_KEY, TRIGGER_TEMPLATES_QUERY_KEY} from "../queryKeys";
import {ReachTemplateOption} from "../templates/types";

type Variables = {};

const getTriggerTemplates = async (): Promise<ReachTemplateOption[]> => {
  const response = await axiosReachInstance.get<ReachTemplateOption[], AxiosResponse<ReachTemplateOption[]>>(
    "/triggers/templates"
  );
  return response.data;
};

export const useGetTriggerTemplates = (
  variables: Variables = {},
  options?: BaseQueryOptions<ReachTemplateOption[], Variables>
): BaseUseQueryResult<ReachTemplateOption[]> => {
  return useBaseQuery<ReachTemplateOption[], Variables>(
    [TEMPLATES_QUERY_KEY, TRIGGER_TEMPLATES_QUERY_KEY],
    getTriggerTemplates,
    variables,
    options
  );
};
